// extracted by mini-css-extract-plugin
export default {"videoPage":"VideoPage_videoPage__PhVAt","sectionOne":"VideoPage_sectionOne__NXoqI"};